// In-memory only — never persisted. Repopulated each page load via AuthProvider's bootstrap.

/** @type {string | null} */
let accessToken = null;

/** @returns {string | null} */
export function getAccessToken() {
  return accessToken;
}

/** @param {string} token */
export function setAccessToken(token) {
  accessToken = token;
}

export function clearAccessToken() {
  accessToken = null;
}
